import { getReturnURL } from "../auth";
import { getUserPlatform, messageBridge } from "~/scripts/utils";

export const handleCredentialResponse = (response) => {
  const return_to = getReturnURL();
  const credential = response.credential;

  if (credential) {
    let payload = {
      credential,
    };

    if (return_to) {
      payload = {
        ...payload,
        return_to,
      };
    }

    fetch(`https://api.wooltariusa.com/auth/google/callback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Locale": window.Shopify.locale,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        const { token, code, customer } = data;

        if (code === "auth/new-customer") {
          // Facebook
          window?.fbq("track", "CompleteRegistration");
          // Google
          window?.gtag("event", "sign_up", { method: "google" });
          // Taboola
          // window?._tfa.push({ notify: "event", name: "signup", id: 1564798 });
          // Mobile Native
          messageBridge.postMessage({
            type: "analytics",
            payload: {
              event: "signup",
              properties: {
                method: "google",
              },
            },
          });

          window?.ttq.track("CompleteRegistration", {
            method: "google",
          });

          // Track with customer
          if (customer) {
            // Miaxpanel
            window?.mixpanel.alias(`${customer.id}`);
            window?.mixpanel.track("signup", {
              $first_name: `${customer.first_name}`,
              $last_name: `${customer.last_name}`,
              $email: `${customer.email}`,
              platform: `${getUserPlatform()}`,
              referral: `google`,
            });
            // Twitter
            window?.twq("event", "tw-od7mn-od7mv", {
              status: "completed",
              description: "google",
              email_address: customer?.email,
            });
          }
        }

        if (token) {
          window.location = `${window.Shopify.routes.root}account/login/multipass/${token}`;
        }
      })
      .catch((error) => console.log(error));
  }
};

export default { handleCredentialResponse };
